
const BannerFamiliar = () => {
    let $banner = document.querySelector('.bannerFamiliar');
    if (!$banner) { return false; }

    let $cerrar = document.querySelector('.bannerFamiliar__cerrar');

    let stickyScroll = () => {
        if (window.pageYOffset > 0) {
            $banner.classList.add('noSticky');
        }
    };
    let cerrarPlan = () => {
        $banner.classList.add('noSticky');
    };
    let limiteDeHeight = () => {
        if (window.innerWidth > 1023 && window.innerHeight > 700) {
            $banner.classList.add('noSticky');
        }
    } 

    //no sticky cuando clickea en cerrar
    $cerrar.addEventListener('click', () => { cerrarPlan(); });

    // no sticky cuando hace el primer scroll
    window.onscroll = () => { stickyScroll(); };

    //no sticky cuando es desktop y el height es mas chico que 700
    limiteDeHeight();
};


module.exports = {
    init: () => {
        BannerFamiliar();
    }
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/bannerFamiliar.js